export const tr = {
    id: 'id',
    'product-description': 'ürün açıklaması',
    'product-name': 'ürün adı'
};
